// extracted by mini-css-extract-plugin
export default {"box":"Ecosystem_box__8rwvy","stack":"Ecosystem_stack__b74zQ","graphic":"Ecosystem_graphic__E4bTs"};